import React from "react";
// import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation, Route, Redirect } from "react-router-dom";

const ProtectedAuthRoute = ({ children, component: Component, ...rest }) => {
  const location = useLocation();
  const { userData } = useSelector((state) => state.auth);

  return (
    <Route
      {...rest}
      render={({ props }) =>
        userData?.email ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default ProtectedAuthRoute;
